import script from "./PropostaDcoumentosRepository.vue?vue&type=script&lang=js"
export * from "./PropostaDcoumentosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__